import React from "react";
import { Link } from "react-router-dom";

import { PLATFORM_FOOTER_TEXT } from "@/lib/polenica";

export default function PlatformFooter() {
  return (
    <footer className="border-t border-primary/10 bg-[linear-gradient(180deg,#EEF5E8_0%,#DDEADA_100%)]">
      <div className="mx-auto flex max-w-7xl flex-col gap-4 px-4 py-6 sm:px-6 lg:px-8 lg:flex-row lg:items-start lg:justify-between">
        <p className="max-w-4xl text-sm leading-6 text-[#486150]">{PLATFORM_FOOTER_TEXT}</p>
        <div className="flex flex-wrap gap-3 text-sm font-semibold text-primary">
          <Link to="/quienes-somos" className="transition hover:text-[#254935]">
            Quiénes somos
          </Link>
          <Link to="/inicio" className="transition hover:text-[#254935]">
            Inicio
          </Link>
        </div>
      </div>
    </footer>
  );
}
